import { render, staticRenderFns } from "./questions-table.vue?vue&type=template&id=5d8bec10"
import script from "./questions-table.vue?vue&type=script&lang=js"
export * from "./questions-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports